import React__default from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("InteractiveTags", {
  root: css`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    // TODO: Switch to Flexbox 'gap' when Safari supports it
    // and remove 'Styles.item' entirely.
    margin-bottom: -10px;
  `,
  item: css`
    margin-bottom: 10px;
    &:not(:last-child) {
      margin-right: 10px;
    }
  `
});
const InteractiveTags = (props) => {
  const tags = React__default.Children.toArray(props.children).filter(Boolean).map((child, i) => {
    return jsx("li", { css: Styles.item, key: i }, child);
  });
  return jsx("ul", { "aria-label": props.ariaLabel, css: Styles.root, "data-zds": true }, tags);
};

export { InteractiveTags };
//# sourceMappingURL=InteractiveTags.es.js.map
